
/// <amd-module name="Wit/WorkItemFormMarkdown/MarkdownUtils" />
import * as TurndownService from "turndown";
import { nestedLists } from "./NestedListsPlugin";
import { tables } from "./TablesPlugin";

export function convertHTMLCommentToMarkdown(comment: string): string {
    const turndownService = new TurndownService();
    turndownService.use(tables);
    turndownService.use(nestedLists);
    turndownService.keep('mark');
    const htmlDataWithoutComments = comment.replace(/<\!--(?!>)[\S\s]*?-->/g, "");
    return unescapeString(turndownService.turndown(htmlDataWithoutComments)) || "";
}

function unescapeString(str: string): string {
    return str.replace(/(?:\\(.))/g, '$1');
}

const pullRequestSign = "!";
const workItemSign = "#";
const personSign = "@";
export const convertMentions = (htmlContent: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        try {
            const tempElement = document.createElement("div");
            tempElement.innerHTML = htmlContent;
            const anchors = tempElement.querySelectorAll("a[data-vss-mention]");
            for (let i = 0; i < anchors.length; ++i) {
                const anchor = anchors[i];
                let mentionElement: Text | null = null;
                const href = anchor.getAttribute("href");
                const content = anchor.innerHTML;
                const prMatches = href ? /^.*\/pullrequest\/([0-9]+)(?:\?\_a\=.+)*$/gi.exec(href) : undefined;
                if (prMatches && prMatches.length > 1) {
                    const pullRequestId = prMatches[1];
                    mentionElement = pullRequestId ? document.createTextNode(`${pullRequestSign}${pullRequestId}`) : null;
                }
                if (content?.match(/^#[0-9]+$/gi)) {
                    const workItemId = content.substring(1);
                    mentionElement = workItemId ? document.createTextNode(`${workItemSign}${workItemId}`) : null;
                }
                if (content?.match(/^@.+$/gi)) {
                    const mentionId = anchor.getAttribute("data-vss-mention")?.split(",").pop();
                    mentionElement = mentionId ? document.createTextNode(`${personSign}<${mentionId}>`) : null;
                }

                if (mentionElement) {
                    anchor.parentElement?.insertBefore(mentionElement, anchor);
                    anchor.remove();
                }
            }

            resolve(tempElement.innerHTML);
        } catch (error) {
            reject(error);
        }
    });
};

export async function convertHTMLToMarkdown(content: string) {
    let convertedContent: string;
    try {
        convertedContent = await convertMentions(content);
    } catch {
        convertedContent = content;
    }

    return convertHTMLCommentToMarkdown(convertedContent);
}
